import InfoModal from './info_modal'

export default InfoModal